import { render, staticRenderFns } from "./question-blocks.vue?vue&type=template&id=6089b764&"
import script from "./question-blocks.vue?vue&type=script&lang=js&"
export * from "./question-blocks.vue?vue&type=script&lang=js&"
import style0 from "./question-blocks.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports